import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
import { jwtDecode } from "jwt-decode";

// FastAPI store: POST /api/v1/store/auth/register → { token, message }
export const customer_register = createAsyncThunk(
    'auth/customer_register',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/auth/register', info)
            localStorage.setItem('customerToken', data.token)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: POST /api/v1/store/auth/login → { token, message }
export const customer_login = createAsyncThunk(
    'auth/customer_login',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/auth/login', info)
            localStorage.setItem('customerToken', data.token)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

const decodeToken = (token) => {
    if (token) {
        try {
            const userInfo = jwtDecode(token)
            // Verificar que no esté expirado
            if (new Date() > new Date(userInfo.exp * 1000)) {
                localStorage.removeItem('customerToken')
                return ''
            }
            return userInfo
        } catch {
            return ''
        }
    }
    return ''
}

export const authReducer = createSlice({
    name: 'auth',
    initialState: {
        loader: false,
        userInfo: decodeToken(localStorage.getItem('customerToken')),
        errorMessage: '',
        successMessage: '',
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        user_reset: (state) => {
            state.userInfo = ''
            localStorage.removeItem('customerToken')
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(customer_register.pending, (state) => { state.loader = true })
        .addCase(customer_register.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || payload?.detail || 'Error al registrarse'
            state.loader = false
        })
        .addCase(customer_register.fulfilled, (state, { payload }) => {
            state.userInfo = decodeToken(payload.token)
            state.successMessage = payload.message
            state.loader = false
        })

        .addCase(customer_login.pending, (state) => { state.loader = true })
        .addCase(customer_login.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || payload?.detail || 'Credenciales incorrectas'
            state.loader = false
        })
        .addCase(customer_login.fulfilled, (state, { payload }) => {
            state.userInfo = decodeToken(payload.token)
            state.successMessage = payload.message
            state.loader = false
        })
    }
})

export const { messageClear, user_reset } = authReducer.actions
export default authReducer.reducer
